import { module } from 'modujs';

export default class extends module {
    constructor(m) {
        super(m);

        this.events = {
            click: {
                toggler: 'toggle'
            }
        }
    }

    init() {
        if(window.location.hash == '#recover') {
            this.el.classList.add('is-forgot-password')
        }
    }

    toggle() {
        if(this.el.classList.contains('is-forgot-password')) {
            this.el.classList.remove('is-forgot-password')
        } else {
            this.el.classList.add('is-forgot-password')
        }
    }
}
